import Vue from 'vue';
import Vuex from 'vuex';
// import VuexI18n from 'vuex-i18n' // load vuex i18n module
import header from './modules/header';
import writeReview from './modules/writeReview';
import auth from './modules/auth';
import category from './modules/category';
import modal from './modules/modal';
import screen from './modules/screen';
import filterProduct from './modules/filterProduct';
import productDetail from './modules/productDetail';
import product from './modules/product';
import review from './modules/review';
import categories from './modules/categories/categories-index';
import products from 'vuex-store/modules/products/products-index';
import addProduct from './modules/addProduct';
import profile from './modules/profile';
import $_InternalTracking from './modules/$_InternalTracking.store';
import Cookies from 'js-cookie';
import ModalTour from '@/components/global/modal/modal-tour.vue';
import $_SearchHeader from './$_SearchHeader.store';
import $_Header from './$_Header.store';
import $_SearchPage from './$_SearchPage.store';
import $_URI from './$_URI.store';
import $_Review from './$_Review.store';
import $_CuratedProduct from './$_CuratedProduct.store';
import $_Brand from './$_Brand.store';
import $_Category from './$_Category.store';
import otp from './modules/otp';
import { toPng } from 'dom-to-image';

const Config = require('~/config/default.env').default;

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  modules: {
    header,
    auth,
    writeReview,
    category,
    modal,
    screen,
    filterProduct,
    productDetail,
    product,
    review,
    categories,
    products,
    addProduct,
    profile,
    $_InternalTracking,
    $_SearchHeader,
    $_Header,
    $_SearchPage,
    $_URI,
    $_Review,
    $_CuratedProduct,
    $_Brand,
    $_Category,
    otp,
  },
  state: {
    SOCO_WEB_URL: Config.SOCO_WEB_URL,
    BJ_WEB_URL: Config.BJ_WEB_URL,
    REVIEW_WEB_URL: Config.REVIEW_WEB_URL,
    SOCIOLLA_WEB_URL: Config.SOCIOLLA_WEB_URL,
    LULLA_WEB_URL: Config.LULLA_WEB_URL,
    consoleLogMode: Config.consoleLogMode ? Config.consoleLogMode : false,
    redirectUrl: '',
    departmentIdActive: '',
    userimage: null,
    userfirstname: '',
    userlastname: '',
    userFullName: '',
    user_name: '',
    username: '',
    user_id: '',
    userProfile: '',
    popularReviewPerCategory: {},
    activeHeaderMenu: '',
    brands: '',
    brands_origin: '',
    otpNumber: '',
    tempUserId: '',
    brands: '',
    currentUrl: '',
    tours: [],
    featuredBrands: [],
    reviewedBrands: [],
    reviewData: {},
    reviewDetail: {},
    isResetPasswordTokenExpired: false,
    modalShareFromLogin: false,
  },
  mutations: {
    setFeaturedBrands(state, value) {
      state.featuredBrands = state.featuredBrands.concat(value);
    },
    setReviewedBrands(state, value) {
      state.reviewedBrands = value;
    },
    setBrands(state, value) {
      state.brands = value;
    },
    setModalOpen(state, payload) {
      state.modalIsOpen = payload;
    },
    setRedirectURL(state, payload) {
      state.redirectUrl = payload;
    },
    setModalShareFromLogin(state, payload) {
      state.modalShareFromLogin = payload;
    },
    setDataBrands(state, dataBrands) {
      state.brands = dataBrands;
    },
    setDataBrandsOrigin(state, dataBrandsOrigin) {
      state.brands_origin = dataBrandsOrigin;
    },
    setDataPopularReviewPerCategory(state, { data, slug }) {
      this._vm.$set(state.popularReviewPerCategory, slug, data);
    },
    setActiveHeaderMenu(state, name) {
      state.activeHeaderMenu = name;
    },
    updateDepartmentIdActive(state, newDepartmentId) {
      state.departmentIdActive = newDepartmentId;
    },
    userProfile(state, data) {
      state.userProfile = data;
    },
    otpNumber(state, data) {
      state.otpNumber = data;
    },
    setTempUserId(state, data) {
      state.tempUserId = data;
    },
    currentUrl(state, data) {
      state.currentUrl = data;
    },
    setTours(state, data) {
      state.tours = data;
    },
    setReviewData(state, data) {
      state.reviewData = data;
    },
    setReviewDetail(state, data) {
      state.reviewDetail = data;
    },
    setResetPasswordTokenExpired(state, value) {
      state.isResetPasswordTokenExpired = value;
    },
  },
  actions: {
    updateRedirectState({ commit, state, dispatch }, newVal) {
      commit('setRedirectState', newVal);
    },
    updateRedirectURL({ commit, state, dispatch }, newVal) {
      commit('setRedirectURL', newVal);
    },
    toggleSideMenu({ commit, state, dispatch }, data) {
      commit('sideMenu', state.sideMenu ? false : true);
    },
    addSearchHistory({ commit }, { entity_id, keyword }) {
      const params = {
        entity_id: entity_id, // id product
        keyword: keyword, // keyword yg dimasukin
        entity_type: 'product',
      };
      return axios.post(`${Config.MS_SOCO_PUBLIC_API_URL}/search-history-clicks`, params);
    },
    // getCategoryPopularReview ({ commit, state }, config) {

    // 	this._vm.$MS_SOCO_PUBLIC_API_URL
    //       .get(`/products`, {
    //         params: config.params
    //       })
    //       .then(response => {
    //         if (response.status === 200) {
    //           commit('setDataPopularReviewPerCategory', {
    //           	data: response.data.data,
    //           	slug: config.categoryName
    //           })
    //         }
    //       })
    //       .catch((error) => {
    //       	console.log(error)
    //       })
    // },
    getPopularProductPerCategory({ commit, state }, config) {
      return this._vm.$MS_SOCO_PUBLIC_API_URL.get(`/products`, {
        params: {
          ...config.params,
          fields:
            'id name brand images review_stats total_reviews default_category parent_category is_wishlist combinations',
        },
      });
    },
    getBrands({ commit }) {
      return this._vm.$MS_SOCO_PUBLIC_API_URL
        .get('/brands/letter', {
          params: {
            section: 'getBrands',
            fields: 'my_soco_sql_id name logo',
            limit: 300,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            commit('setDataBrands', response.data.data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getBrandsOrigin({ commit }) {
      this._vm.$MS_CATALOG_API_URL
        .get('/v3/brands/letters', {
          params: {
            fields: 'name,logo,slug',
            limit: 100,
            sort: 'name',
          },
        })
        .then((response) => {
          if (response.status === 200) {
            const brandsMenu = Object.keys(response.data.data || {}).reduce((accu, key) => {
              response.data.data[key].forEach((brand) => {
                const { _id: id_manufacturer } = brand;
                accu.push(Object.assign({ id_manufacturer }, brand));
              });
              return accu;
            }, []);

            if (brandsMenu.length) {
              const sortedBrand = brandsMenu
                .filter((b) => b.country)
                .sort(function (a, b) {
                  const nameA = a.country.toUpperCase();
                  const nameB = b.country.toUpperCase();
                  if (nameA < nameB) {
                    return -1;
                  }
                  if (nameA > nameB) {
                    return 1;
                  }
                  return 0;
                });

              const country = {};
              sortedBrand.forEach((brand) => {
                if (!country[brand.country] && brand.country) {
                  country[brand.country] = brand;
                }
              });

              const isAlphabet = (char) => char.match(/^[A-Za-z]+$/);
              const letters = {
                '#': [],
                A: [],
                B: [],
                C: [],
                D: [],
                E: [],
                F: [],
                G: [],
                H: [],
                I: [],
                J: [],
                K: [],
                L: [],
                M: [],
                N: [],
                O: [],
                P: [],
                Q: [],
                R: [],
                S: [],
                T: [],
                U: [],
                V: [],
                W: [],
                X: [],
                Y: [],
                Z: [],
              };

              for (const [key, value] of Object.entries(country)) {
                const firstChar = key[0] == ' ' ? key.replace(' ', '')[0].toUpperCase() : key[0].toUpperCase();
                const isAlpha = isAlphabet(firstChar);
                if (isAlpha) {
                  letters[firstChar].push(value);
                } else {
                  letters['#'].push(value);
                }
              }
              commit('setDataBrandsOrigin', letters);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setQuickTour({ commit, state }, coachmark) {
      Cookies.set(coachmark, true);
      if (state.auth.loggedin) {
        axios
          .put(`${Config.MS_SOCO_PUBLIC_API_URL}/users/${state.auth.user_id}`, {
            coachmark_visited: [coachmark],
          })
          .then((response) => {
            if (response.status === 200) {
              const newProfile = { ...state.userProfile };
              newProfile.coachmark_visited.push(coachmark);
              commit('userProfile', { ...newProfile });
              console.log('new ', newProfile);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    showTour({ commit, state }, { index, coachmark, cookie }) {
      const coachmark_visited = (state.userProfile && state.userProfile.coachmark_visited) || [];
      let show = false;
      const activeTour = state.tours[index];
      if (state.auth.loggedIn) {
        if (cookie) {
          if (!Cookies.get(cookie)) {
            show = true;
          }
        } else {
          if (!coachmark) {
            coachmark = activeTour.coachmark;
          }
          if (coachmark && !coachmark_visited.includes(coachmark)) {
            show = true;
          }
        }
      } else {
        if (cookie && !Cookies.get(cookie)) {
          show = true;
        }
      }

      if (state.tours.length && show) {
        if (cookie) {
          activeTour['cookie'] = cookie;
        }
        const elm = document.getElementById(activeTour.id);
        if (elm) {
          const ComponentClass = Vue.extend(ModalTour);
          const instance = new ComponentClass({
            propsData: {
              tours: state.tours,
              active: activeTour,
              close: function () {
                this.$el.remove();
              },
            },
            store,
          });
          instance.$mount();
          elm.appendChild(instance.$el);
        }
      } else {
        commit('setTours', []);
      }
    },
    setCookie({ commit }, cookie) {
      Cookies.set(cookie.name, cookie.value);
    },
    getShareTemplate({ state }, { type, id }) {
      let domID;
      switch (type) {
        case 'wa':
          domID = 'share-wa';
          break;
        case 'fb':
          domID = 'share-fb';
          break;
        default:
          domID = 'share-wa';
          break;
      }
      return new Promise((resolve) => {
        setTimeout(() => {
          const doc = document.getElementById(`${domID}-${id || state.reviewData._id}`);
          if (doc) {
            return toPng(doc, { quality: 0.9 })
              .then(resolve)
              .catch(() => resolve(''));
          }
          resolve('');
        }, 2000);
      });
    },
  },
});

// Vue.use(VuexI18n.plugin, store)

export default store;
